import {connect, MapDispatchToPropsObject} from 'react-redux';
import {IStore} from '../../../redux/auth/reducers';
import {userForgotPassword} from '../../../redux/auth/actions';
import {getConnectionRefusedError, getErrorMessage} from '../service';
import {IForgotPasswordConnected} from './types';
import {ForgotPassword as Container} from './forgot-password';

const mapStateToProps = ({auth}: IStore): IForgotPasswordConnected => ({
  connectionRefusedError: getConnectionRefusedError(auth.provider, auth.apiErrors),
  apiEmailError: getErrorMessage('email', auth.provider, auth.apiErrors),
  emailSent: auth.emailSent,
  isLoading: auth.isLoading,
});

const mapDispatchToProps: MapDispatchToPropsObject = {
  forgotPassword: userForgotPassword,
};

export const UserForgotPassword = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Container);
